import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiResListsType } from 'global-services/api/OhsApiModels';
import OhsResourceCentreRecord from 'resource-centre/models/OhsResourceCentreRecord';
import { OhsResourceCentreRootState } from 'resource-centre/models/OhsResourceCentreModels';
import { OhsResourceCentreFilterPayload } from 'resource-centre/OhsResourceCentreModels';
import getResources from 'resource-centre/OhsResourceCentreServices';
import { TierType } from 'global-services/constants/OhsObject';
import OhsUserLocalServices from 'user/OhsUserLocalServices';

const resourceCentreFilterOptions = (
  state: OhsResourceCentreRootState,
  count: boolean
): OhsResourceCentreFilterPayload => {
  const {
    globalfilter: {
      filterInfo: { resourceCentreModule: filterInfo },
    },
  } = state;
  const { currentViewPreset, currentPage } = state.resourceCentre;
  return {
    sort: JSON.parse(filterInfo.sort),
    viewPreset: currentViewPreset,
    page: currentPage,
    archived: filterInfo.archive,
    next:
      currentPage >= 10
        ? JSON.parse(state.resourceCentre.resourceCentreList?.pagination?.next ?? '')
        : '',
    count,
  };
};

export const fetchResourceCentreListsCountAsync = createAsyncThunk<ApiResListsType<
  OhsResourceCentreRecord[]
> | null>('resourceCentre/fetchResourceCentreListWithCount', async (_, thunkAPI) => {
  const state = thunkAPI.getState() as OhsResourceCentreRootState;
  const user = OhsUserLocalServices.getLocalOhsUser();

  try {
    if (user?.tier.type === TierType.T1) {
      const resourceCentreFiltersWithCount = resourceCentreFilterOptions(state, true);
      const response = await getResources(resourceCentreFiltersWithCount);
      return response;
    }
    return null;
  } catch (err: any) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});

export const fetchResourceCentreListsAsync = createAsyncThunk<ApiResListsType<
  OhsResourceCentreRecord[]
> | null>('resourceCentre/fetchResourceCentreLists', async (_, thunkAPI) => {
  const state = thunkAPI.getState() as OhsResourceCentreRootState;
  const user = OhsUserLocalServices.getLocalOhsUser();

  try {
    if (user?.tier.type === TierType.T1) {
      const resourceCentreFiltersWithCount: OhsResourceCentreFilterPayload =
        resourceCentreFilterOptions(state, false);
      const response = await getResources(resourceCentreFiltersWithCount);
      return response;
    }
    return null;
  } catch (err: any) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});
